import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { Form } from 'components/ui/atoms';
import { AddressSchema } from '../types';
import { useStateOptions } from './hooks';
import { AddressFormProps } from './types';

export const AddressStateField = ({ isDisabled }: AddressFormProps) => {
  const { control, setValue } = useFormContext<AddressSchema>();
  const selectedCountry = useWatch({
    control,
    name: 'country',
    defaultValue: '',
  });
  const stateOptions = useStateOptions(selectedCountry);

  // clear selected state when selected country changes
  useEffect(() => {
    setValue('stateCode', stateOptions.length > 1 ? '' : 'not-required');
    setValue('state', '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCountry]);

  return stateOptions.length > 1 ? (
    <Form.Select
      name="stateCode"
      label={
        <FormattedMessage
          id="payment.form.address.state.required"
          defaultMessage="State/Province (required)"
          description="Label for State Select"
        />
      }
      options={stateOptions}
      autocomplete="address-level1"
      styleClasses="col-lg-6"
      disabled={isDisabled}
    />
  ) : (
    <Form.Input
      name="state"
      label={
        <FormattedMessage
          id="payment.form.address.state"
          defaultMessage="State/Province"
          description="Label for Form Input"
        />
      }
      autocomplete="address-level1"
      styleClasses="col-lg-6"
      maxLength={20}
      disabled={isDisabled}
    />
  );
};
